module.exports = __webpack_public_path__ + "img/stones.78dc68ad.png";